/**
 * Helper function to generate full GitHub CDN image URLs
 * @param {string} imageName - Name or relative path of the image file
 * @returns {string} Fully qualified CDN URL or placeholder
 */
export const getCdnImageUrl = (imageName) => {
  if (!imageName) return '';
  if (imageName.startsWith('http://') || imageName.startsWith('https://')) {
    return imageName;
  }
  // Primary CDN source: jsDelivr GitHub CDN
  return `https://cdn.jsdelivr.net/gh/shantpinku/halftimewhistle-cdn@master/${imageName}`;
};
